export default __webpack_public_path__ + "static/media/PolygonSvg.491e2c31.svg";